import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import * as React from 'react';
export default {
  FontAwesomeIcon,
  faCalendarAlt,
  React
};